import { E_BybitTransactionTypes, SelectHistoryTransactionOptions } from '@/redux/transactions/transactions.types'

export const options: SelectHistoryTransactionOptions<E_BybitTransactionTypes>[] = [
  { label: 'TRANSFER_IN', value: E_BybitTransactionTypes.TRANSFER_IN },
  { label: 'TRANSFER_OUT', value: E_BybitTransactionTypes.TRANSFER_OUT },
  { label: 'TRADE', value: E_BybitTransactionTypes.TRADE },
  { label: 'AUTO_SOLD_COLLATERAL_INS_LOAN', value: E_BybitTransactionTypes.AUTO_SOLD_COLLATERAL_INS_LOAN },
  { label: 'SETTLEMENT', value: E_BybitTransactionTypes.SETTLEMENT },
  { label: 'INTEREST_REPAYMENT_INS_LOAN', value: E_BybitTransactionTypes.INTEREST_REPAYMENT_INS_LOAN },
  { label: 'DELIVERY', value: E_BybitTransactionTypes.DELIVERY },
  { label: 'LIQUIDATION', value: E_BybitTransactionTypes.LIQUIDATION },
  { label: 'AIRDROP', value: E_BybitTransactionTypes.AIRDROP },
  { label: 'BONUS', value: E_BybitTransactionTypes.BONUS },
  { label: 'BONUS_RECOLLECT', value: E_BybitTransactionTypes.BONUS_RECOLLECT },
  { label: 'INTEREST', value: E_BybitTransactionTypes.INTEREST },
  { label: 'FEE_REFUND', value: E_BybitTransactionTypes.FEE_REFUND },
  { label: 'CURRENCY_BUY', value: E_BybitTransactionTypes.CURRENCY_BUY },
  { label: 'CURRENCY_SELL', value: E_BybitTransactionTypes.CURRENCY_SELL },
  { label: 'PRINCIPLE_REPAYMENT_INS_LOAN', value: E_BybitTransactionTypes.PRINCIPLE_REPAYMENT_INS_LOAN },
  { label: 'BORROWED_AMOUNT_INS_LOAN', value: E_BybitTransactionTypes.BORROWED_AMOUNT_INS_LOAN },
  { label: 'AUTO_BUY_LIABILITY_INS_LOAN', value: E_BybitTransactionTypes.AUTO_BUY_LIABILITY_INS_LOAN },
  { label: 'AUTO_PRINCIPLE_REPAYMENT_INS_LOAN', value: E_BybitTransactionTypes.AUTO_PRINCIPLE_REPAYMENT_INS_LOAN },
  { label: 'AUTO_INTEREST_REPAYMENT_INS_LOAN', value: E_BybitTransactionTypes.AUTO_INTEREST_REPAYMENT_INS_LOAN },
  { label: 'TRANSFER_IN_INS_LOAN', value: E_BybitTransactionTypes.TRANSFER_IN_INS_LOAN },
  { label: 'TRANSFER_OUT_INS_LOAN', value: E_BybitTransactionTypes.TRANSFER_OUT_INS_LOAN },
  { label: 'SPOT_REPAYMENT_SELL', value: E_BybitTransactionTypes.SPOT_REPAYMENT_SELL },
  { label: 'SPOT_REPAYMENT_BUY', value: E_BybitTransactionTypes.SPOT_REPAYMENT_BUY },
  { label: 'TOKENS_SUBSCRIPTION', value: E_BybitTransactionTypes.TOKENS_SUBSCRIPTION },
  { label: 'TOKENS_REDEMPTION', value: E_BybitTransactionTypes.TOKENS_REDEMPTION },
  { label: 'AUTO_DEDUCTION', value: E_BybitTransactionTypes.AUTO_DEDUCTION },
  { label: 'FLEXIBLE_STAKING_SUBSCRIPTION', value: E_BybitTransactionTypes.FLEXIBLE_STAKING_SUBSCRIPTION },
  { label: 'FLEXIBLE_STAKING_REDEMPTION', value: E_BybitTransactionTypes.FLEXIBLE_STAKING_REDEMPTION },
  { label: 'FIXED_STAKING_SUBSCRIPTION', value: E_BybitTransactionTypes.FIXED_STAKING_SUBSCRIPTION },
  { label: 'PREMARKET_TRANSFER_OUT', value: E_BybitTransactionTypes.PREMARKET_TRANSFER_OUT },
  { label: 'PREMARKET_DELIVERY_SELL_NEW_COIN', value: E_BybitTransactionTypes.PREMARKET_DELIVERY_SELL_NEW_COIN },
  { label: 'PREMARKET_DELIVERY_BUY_NEW_COIN', value: E_BybitTransactionTypes.PREMARKET_DELIVERY_BUY_NEW_COIN },
  {
    label: 'PREMARKET_DELIVERY_PLEDGE_PAY_SELLER',
    value: E_BybitTransactionTypes.PREMARKET_DELIVERY_PLEDGE_PAY_SELLER,
  },
  { label: 'PREMARKET_DELIVERY_PLEDGE_BACK', value: E_BybitTransactionTypes.PREMARKET_DELIVERY_PLEDGE_BACK },
  { label: 'PREMARKET_ROLLBACK_PLEDGE_BACK', value: E_BybitTransactionTypes.PREMARKET_ROLLBACK_PLEDGE_BACK },
  {
    label: 'PREMARKET_ROLLBACK_PLEDGE_PENALTY_TO_BUYER',
    value: E_BybitTransactionTypes.PREMARKET_ROLLBACK_PLEDGE_PENALTY_TO_BUYER,
  },
]
